import OneWatchCohortModal from './OneWatchCohortModal'

export default OneWatchCohortModal
// eslint-disable-next-line import/export
export * from './OneWatchCohortModal'
